// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".challengesList_row__1RLzO {\n  display: flex;\n  justify-content: space-evenly;\n  padding: 7px 17px;\n  background: var(--table-bg);\n  align-items: center;\n  cursor: pointer;\n}\n.challengesList_row__1RLzO .challengesList_vs__3ltEr {\n  display: flex;\n  align-items: center;\n  opacity: 0.5;\n}\n.challengesList_row__1RLzO .challengesList_vs__3ltEr svg {\n  margin-right: 0.7em;\n}", ""]);
// Exports
exports.locals = {
	"row": "challengesList_row__1RLzO",
	"vs": "challengesList_vs__3ltEr"
};
module.exports = exports;
